import { useContext, useEffect, useState } from "react";
import "./signUp.scss";
import SignUpBody from "./SignUp/index";
import Password from "components/Password/index";
import SignupSuccess from "containers/SignUpContainer/success/signupSuccess";
import Authentication from "containers/AuthenticationPage/index";
import BYOS from "containers/BYOS/index";
import OrganisationProfile from "containers/OrganisationProfile/index";
import VerifyOtp from "containers/OtpScreen/index";
import RazorpayPayment from "containers/OrganisationProfile/RazorPay/index";
import Success from "components/success/index";
import { signupContext } from "context/SignupContext";
import SecurityQuestion from "containers/SignUpContainer/securityQuestions/securityQuestion";
import SignupNavigation from "./SignupNavigation";
import { useNavigate } from "react-router-dom";

const SignUp = () => {

  const [step, setStep] = useState(1); // Start with pricing (step 1)
  // Functions to move between steps
  const nextStep = (val) => {
    setStep(val || step + 1);
  };
  const navigate = useNavigate();
  const prevStep = () => {
    if (step === 7 || step === 8) return; // Prevent backward navigation from Payment stages
    setStep(step - 1);
  };
  const [successState, setSuccessState] = useState(false);
  const [individualSuccessState, setIndividualSuccessState] = useState(false);
  const [change, setChange] = useState("pricing");
  const [selectedPlanIndex, setSelectedPlanIndex] = useState(null);
  const [canGoNext, setCanGoNext] = useState(false);
  const { isTypeSelect } = useContext(signupContext);

  const navigateHandler = () => {
    const theme = localStorage.getItem("theme") || "light";
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem("theme", theme);
    navigate("/signin");
    window.location.reload();
  };

  const { formData, selectedPlanData, resetSignupData } = useContext(signupContext);
  const [orgUserSuccess, setOrgUserSuccess] = useState(false);

  useEffect(() => {
    // Clear all signup data when the component mounts (new signup session)
    resetSignupData();
  }, []);

  useEffect(() => { }, [isTypeSelect]);
  const [selectedQuestions, setSelectedQuestions] = useState(["", "", ""]);
  const [answers, setAnswers] = useState(["", "", ""]);

  return (
    <>
      {step && !successState && !individualSuccessState && !orgUserSuccess && step > 0 && (
        <SignupNavigation 
          currentStep={step} 
          setStep={setStep} 
        />
      )}
      {/* Step 1: Show Pricing Plans First */}
      {step === 1 && (
        <OrganisationProfile
          nextStep={nextStep}
          prevStep={prevStep}
          change={change}
          setChange={setChange}
          setSelectedPlanIndex={setSelectedPlanIndex}
        />
      )}

      {/* Step 2-6: Signup Flow */}
      {step === 2 && <SignUpBody nextStep={nextStep} prevStep={prevStep} setCanGoNext={setCanGoNext} />}
      {step === 3 && <Password nextStep={nextStep} isReset={false} setCanGoNext={setCanGoNext} />}
      {step === 4 &&
        <SecurityQuestion
          nextStep={nextStep}
          askQuestions={true}
          selectedQuestions={selectedQuestions}
          setSelectedQuestions={setSelectedQuestions}
          answers={answers}
          setAnswers={setAnswers}
          setCanGoNext={setCanGoNext} />}
      {step === 5 && <Authentication nextStep={nextStep} setCanGoNext={setCanGoNext} />}
      {step === 6 && (
        <VerifyOtp
          nextStep={() => {
            if (selectedPlanData?.price === 0) {
              if (isTypeSelect === "org") {
                setOrgUserSuccess(true);
              } else {
                setIndividualSuccessState(true);
              }
              setStep(null);
            } else {
              setChange("payment");
              nextStep(7);
            }
          }}
          prevStep={prevStep}
          setOrgUserSuccess={setOrgUserSuccess}
          setStep={setStep}
          setIndividualSuccessState={setIndividualSuccessState}
          selectedQuestions={selectedQuestions}
          answers={answers}
          setCanGoNext={setCanGoNext}
        />
      )}
      {/* Step 7: Payment (after signup is complete) */}
      {step === 7 && change === "payment" && (
        <OrganisationProfile
          nextStep={nextStep}
          prevStep={prevStep}
          change={change}
          setChange={setChange}
        />
      )}
      {step === 8 && (
        <RazorpayPayment
          nextStep={nextStep}
          successState={successState}
          setSuccessState={setSuccessState}
          setStep={setStep}
          setChange={setChange}
          setIndividualSuccessState={setIndividualSuccessState}
          onDismissFunction={() => setStep(7)}
        />
      )}
      {successState && (
        <Success
          success={true}
          title="Account Created Successfully"
          subTitle="Your account has been successfully signed up. Enjoy exploring our services!"
          buttonText="Sign In"
          onClick={navigateHandler}
        />
      )}
      {individualSuccessState && (
        <Success
          success={true}
          title="Account Created Successfully"
          subTitle="Your account has been successfully signed up. Enjoy exploring our services!"
          buttonText="Sign in"
          onClick={navigateHandler}
        />
      )}

      {orgUserSuccess && (
        <SignupSuccess
          success={true}
          title="Account Created Successfully"
          subTitle="Your account has been successfully signed up. Enjoy exploring our services!"
          buttonText="Sign In"
          onClick={navigateHandler}
          setStep={setStep}
          setOrgUserSuccess={setOrgUserSuccess}
        />
      )}

      {step==-1 && (
        <BYOS onClose={() => {
          setStep(1);
          setOrgUserSuccess(true);
        }}></BYOS>
      )

      }
    </>
  );
};

export default SignUp;
